// eslint-disable-next-line import/no-extraneous-dependencies
import 'leaflet-loader/leaflet-loader'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'leaflet-loader/leaflet-loader.css'
import { dashUrl, isRx4Route } from '@/config'
import { createDeliveryChecker } from '@/utils/trackingDeliveryArea.mjs'
import L from 'leaflet'
import { computed, reactive, watch } from 'vue'
import { useStore } from 'vuex'

const controlLoader = L.control.loader()
const types_val = reactive({})

const deliveryCheck = reactive({ pending: false, failed: false })
const checkRx4RouteDelivery = createDeliveryChecker(async (clientId, geo) => {
  if (!geo.lat || !geo.lng) {
    throw new Error('The delivery address has no coordinates.')
  }
  const response = await fetch(`${dashUrl}/ajax/PullCommon.php?action=checkDelivery`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ clientId, geo }),
  })
  if (!response.ok) {
    throw new Error('Delivery availability could not be checked.')
  }
  const { types } = await response.json()
  if (!types || typeof types !== 'object' || Array.isArray(types)) {
    throw new Error('Delivery availability is unavailable.')
  }
  return types
}, types_val, deliveryCheck)

function checkDelivery(clientId, geo) {
  if (isRx4Route) {
    return checkRx4RouteDelivery(clientId, geo)
  }
  return fetch(`${dashUrl}/ajax/PullCommon.php?action=checkDelivery`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      typeId: 9,
      clientId,
      geo,
    }),
  })
    .then(result => result.json())
    .then(({ types }) => {
      Object.assign(types_val, types)
    })
}

export function useTypes() {
  const store = useStore()
  const retryDeliveryCheck = () => {
    const { orderData, rescheduleData } = store.getters
    const address = (isRx4Route && rescheduleData?.address) || orderData.recipient.address
    return checkDelivery(orderData.client.uid, { lat: address.lat, lng: address.lng })
  }
  retryDeliveryCheck()

  return { types: types_val, deliveryCheck, retryDeliveryCheck }
}

export default function useAddress(computedAddress) {
  const orderGeo = computed(() => ({ lat: computedAddress.value.lat, lng: computedAddress.value.lng }))
  const { orderData } = useStore().getters

  watch(() => [computedAddress.value.lat, computedAddress.value.lng], v => {
    if (!v[0] || !v[1]) {
      controlLoader.show()
      if (isRx4Route) {
        checkDelivery(orderData.client.uid, orderGeo.value)
      }
      return
    }
    controlLoader.show()
    computedAddress.value.delivery = undefined
    checkDelivery(orderData.client.uid, orderGeo.value)
      .finally(() => {
        controlLoader.hide()
      })
  })

  return { controlLoader, orderGeo }
}
